import GiftPreview from '../common/GiftPreview';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAllAdminPreviousForms, selectShowAdminHistory } from '../../giftSlice';
import { useGetAllFormsQuery } from '../../giftApiSlice';
import FeedbackPreview from '../common/FeedbackPreview';
import AllForms from './AllForms';
import PreviousGift from '../common/PreviousGift';
import { useMediaQuery } from '@mui/material';
import SwipeEdge from '../../../../common/SwipeEdge';
import JuryDetails from '../common/JuryDetails';

const ManageGiftAdmin = () => {
  useGetAllFormsQuery();
  const forms = useSelector(selectAllAdminPreviousForms);
  const showHistory = useSelector(selectShowAdminHistory);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

  return (
    <Grid container sx={{ height: 'calc(100vh - 75px)', border: 0, p: 0 }}>
      {showHistory ? <PreviousGift forms={forms} showEmployee={true} /> : <AllForms />}

      {isMobile ? (
        <SwipeEdge
          title={'GIFT preview'}
          content={
            <GiftPreview>
              <FeedbackPreview />
            </GiftPreview>
          }
          drawerBleeding={0}
        />
      ) : (
        <GiftPreview previewHeight='43vh'>
          <FeedbackPreview />
        </GiftPreview>
      )}
    </Grid>
  );
};

export default ManageGiftAdmin;
